import React, { useRef } from 'react';
import ImageUploading from 'react-images-uploading';
import { Image } from '../../../components';
import './styles.css';

function useImage(commands) {
  const imageRef = useRef();

  const handleChangeImg = (imageList, addUpdateIndex) => {
    commands.startEdit(imageList[0]);
  };

  return ({
    localStates: {
      imageRef,
    },
    eventHandlers: {
      handleChangeImg,
    },
  });
}

export default function ImageAvatar(props) {
  const { remoteStates, commands, sharedStates } = props;
  const { localStates, eventHandlers } = useImage(commands);

  return (
    <ImageUploading
      value={sharedStates?.data?.img ? [sharedStates?.data?.img] : []}
      onChange={eventHandlers.handleChangeImg}
      dataURLKey="data_url"
    >
      {({
        imageList,
        onImageUpload,
        onImageRemoveAll,
        onImageUpdate,
        onImageRemove,
        isDragging,
        dragProps,
      }) => (
        <div className="user-image" ref={localStates.imageRef}>
          <Image src={sharedStates?.data?.img} alt={`Foto de ${remoteStates.user?.firstName} ${remoteStates.user?.lastName}`} rounded edit editAction={onImageUpload} />
        </div>
      )}
    </ImageUploading>

  );
}
